import React from 'react';
import cx from 'classnames';
import linkBg from './layers/shadow.webp.js';
import star1 from './layers/star-1.webp.js';
import star2 from './layers/star-2.webp.js';
import star3 from './layers/star-3.webp.js';
import styles from './index.module.scss.js';

const GradientButtonV2 = ({
  active,
  onClick,
  icon,
  name,
  v2,
  className,
  style,
  size = "md",
  withoutShine = false,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "button",
  {
    onClick,
    className: cx(
      styles.box,
      className,
      {
        [styles.active]: active,
        [styles[size]]: size
      },
      "gradient-button-v2"
    ),
    style,
    type: "button",
    "data-active": active,
    ...props
  },
  /* @__PURE__ */ React.createElement("div", { className: styles.box__inner }, icon && /* @__PURE__ */ React.createElement("div", { className: styles.icon }, icon), /* @__PURE__ */ React.createElement("span", { className: styles.text }, name), /* @__PURE__ */ React.createElement(
    "img",
    {
      className: styles.bg,
      src: linkBg,
      alt: "navigation list background"
    }
  )),
  !withoutShine && active && /* @__PURE__ */ React.createElement(
    "img",
    {
      className: styles["star-1"],
      src: star1,
      alt: "navigation list star1"
    }
  ),
  !withoutShine && active && v2 && /* @__PURE__ */ React.createElement(
    "img",
    {
      className: styles["star-2"],
      src: star2,
      alt: "navigation list star2"
    }
  ),
  !withoutShine && active && v2 && /* @__PURE__ */ React.createElement(
    "img",
    {
      className: styles["star-3"],
      src: star3,
      alt: "navigation list star3"
    }
  )
);
GradientButtonV2.displayName = "GradientButtonV2";

export { GradientButtonV2 };
//# sourceMappingURL=index.js.map
